import React, { useContext } from 'react';
import type { MotionValue } from 'framer-motion';

import type { InteractionDisplayState, InteractionInfo } from '../InteractionInfo';

export interface CardContextState {
  interaction: InteractionInfo;
  inChat?: boolean;
  isSnapped?: boolean;
  noBody?: boolean;
  hasMedia: boolean;
  headerHeight: MotionValue<number>;
  bodyOpacity: MotionValue<number>;
  setHasMedia: (media: boolean) => void;
  attendeeName: string;
  displayState: InteractionDisplayState;
  isEdit: boolean;
}

export const CardContext = React.createContext<CardContextState>({} as unknown as CardContextState);

export function useCardContext(): CardContextState {
  return useContext(CardContext);
}
